import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  sidenav: MatSidenav | any;
  sidenavLogedIn: MatSidenav | any;
  constructor() {}

  public setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  public setSidenavLogedIn(sidenav: MatSidenav) {
    this.sidenavLogedIn = sidenav;
  }

  public toggle(): void {
    this.sidenav.toggle();
  }

  public toggleLogedIn(): void {
    this.sidenavLogedIn.toggle();
  }
}
